import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { EURO_COUNTRY_LIST, Region } from '@lemon8/web-app-shared/i18n';

export interface ILegalMeta {
  displayName: string;
  href: string;
  clickPosition: string;
}

export const useLegalList = (): ILegalMeta[] => {
  const { t } = useTranslation();
  const { region, ipRegion } = useAtomValue($Locale);

  const legalMetas: ILegalMeta[] = [
    { displayName: t('sidebar_privacy'), href: `/legal/privacy?region=${region}`, clickPosition: 'privacy_policy' },
    {
      displayName: t('sidebar_terms'),
      href: `/legal/terms-of-service?region=${region}`,
      clickPosition: 'terms_of_service',
    },
    {
      displayName: t('legal_community_guidelines'),
      href: `/community-guideline?region=${region}`,
      clickPosition: 'community_guidelines',
    },
    {
      displayName: t('legal_intellectual_property'),
      href: `/legal/intellectual-property?region=${region}`,
      clickPosition: 'intellectual_property',
    },
    {
      displayName: t('legal_law_enforcement_guidelines'),
      href: `/legal/law-enforcement-guideline?region=${region}`,
      clickPosition: 'law_enforcement_guidelines',
    },
  ];

  if (EURO_COUNTRY_LIST.includes(ipRegion) || EURO_COUNTRY_LIST.includes(region)) {
    legalMetas.push({
      displayName: 'Cookie Policy',
      href: `/legal/cookies-policy?region=${region}`,
      clickPosition: 'cookie_policy',
    });
  }

  if (region === Region.gb) {
    legalMetas.push({ displayName: 'UK AVMS', href: `/legal/avmsd?region=${region}`, clickPosition: 'avmsd' });
  }

  return legalMetas;
};
